interface Route {
  PATH: string;
  TO: string;
}

interface HomeRoute extends Route {
  CHILDREN_ROUTES: {
    VALIDATION: Route;
    PERSONAL: Route;
    RESIDENCE: Route;
    FINANCE: Route;
    JOB: Route;
    REFERENCES: Route;
    CONFIRM: Route;
    FINISH: Route;
  };
}

interface Routes {
  HOME: HomeRoute;
}

const ROUTES: Routes = {
  HOME: {
    PATH: '/',
    TO: '/',
    CHILDREN_ROUTES: {
      VALIDATION: { PATH: 'validation', TO: '/validation' },
      PERSONAL: { PATH: 'personal', TO: '/personal' },
      RESIDENCE: { PATH: 'residence', TO: '/residence' },
      FINANCE: { PATH: 'finance', TO: '/finance' },
      JOB: { PATH: 'job', TO: '/job' },
      REFERENCES: { PATH: 'references', TO: '/references' },
      CONFIRM: { PATH: 'confirm', TO: '/confirm' },
      FINISH: { PATH: 'finish', TO: '/finish' },
    },
  },
};

export default ROUTES;
